<div class="header-content">
  <img class="header-logo" src="/assets/icons/logo-mw.svg" alt="nMusic Work">
  <div class="separator"></div>
  <div class="player-info">
    <div class="client-name">{{( clientName$ | async ) | uppercase}}</div>
    <div class="player-name">{{( playerName$ | async) | titlecase }}</div>
  </div>
</div>
